module.exports = __webpack_public_path__ + "img/birthday.8ae5b27f.svg";